export class PaymentMethodTypeOptions {
	walletLabel: any = null;
	cardLabel: any = null;
	achLabel: any = null;
	showWallet: boolean = true;
	showCard: boolean = true;
	showAch: boolean = true;
}
